enum PurchaseType {
  NotSpecified = 0,
  Outright = 1,
  PersonalContractPurchase = 2,
  PersonalContractHire = 3,
  HirePurchase = 4,
  BusinessContractHire = 5
}

export default PurchaseType;
